import { createRouter, createWebHashHistory } from 'vue-router'
import FormStart from '../views/FormStart.vue'
import FormStep from '../views/FormStep.vue'

let router = null
if (document.getElementById('eligibility-check') || document.getElementById('eligibility-check-modal')) {
  const routes = [
    {
      path: '/',
      name: 'start',
      component: FormStart
    },
    {
      path: '/step/:step',
      name: 'step',
      props: true,
      component: FormStep
    }
  ]

  router = createRouter({
    history: createWebHashHistory(),
    routes
  })
}

export default router
